/* Requisitions (list, detail, form, print page) and the approvals feature
 * (approval chain stepper). Shared vocabulary lives in common.js. */
const requisitions = {
  // --- List page -------------------------------------------------------------
  'Failed to load requisitions.': 'Gagal memuat permintaan barang.',
  'Purchase requests raised against your properties, routed for approval.': 'Permintaan pembelian yang diajukan untuk properti Anda, diteruskan untuk persetujuan.',
  'New requisition': 'Permintaan barang baru',
  'Search by number, title or requester…': 'Cari berdasarkan nomor, judul, atau pemohon…',
  'My requisitions': 'Permintaan barang saya',
  'All requisitions': 'Semua permintaan barang',
  "Couldn't load requisitions": 'Tidak dapat memuat permintaan barang',
  'No matching requisitions': 'Tidak ada permintaan barang yang cocok',
  'No requisitions yet': 'Belum ada permintaan barang',
  'Try adjusting your search or filters.': 'Coba sesuaikan pencarian atau filter Anda.',
  'Raise your first purchase requisition to get goods approved and ordered.': 'Buat permintaan barang pertama Anda agar barang disetujui dan dipesan.',
  'Title': 'Judul',
  'Lines': 'Baris',
  'Est. total': 'Perkiraan total',
  'Needed by': 'Dibutuhkan sebelum',
  'Priority': 'Prioritas',

  // Status & priority labels (server enum display values)
  'Ordered': 'Dipesan',
  'Low': 'Rendah',
  'Normal': 'Normal',
  'High': 'Tinggi',
  'Urgent': 'Mendesak',

  // --- Detail page -----------------------------------------------------------
  'Requisition not found.': 'Permintaan barang tidak ditemukan.',
  'Not found.': 'Tidak ditemukan.',
  "Couldn't load requisition": 'Tidak dapat memuat permintaan barang',
  'Back to requisitions': 'Kembali ke permintaan barang',
  'Action failed': 'Tindakan gagal',
  'Could not post comment': 'Tidak dapat mengirim komentar',
  'Submitted for approval': 'Diajukan untuk persetujuan',
  'Converted to {number}': 'Dikonversi menjadi {number}',
  'Converted to {count} purchase orders': 'Dikonversi menjadi {count} pesanan pembelian',
  'Could not convert': 'Tidak dapat mengonversi',
  'Requisition cancelled': 'Permintaan barang dibatalkan',
  'A reason is required to reject.': 'Alasan wajib diisi untuk menolak.',
  'Requisition approved': 'Permintaan barang disetujui',
  'Requisition rejected': 'Permintaan barang ditolak',
  'Requisition deleted': 'Permintaan barang dihapus',
  'Could not delete': 'Tidak dapat menghapus',
  'Requested by': 'Diminta oleh',
  'Rejected by': 'Ditolak oleh',
  'Approved by': 'Disetujui oleh',
  'Decided by': 'Diputuskan oleh',
  'Submitted': 'Diajukan',
  'Someone': 'Seseorang',
  'by {name}': 'oleh {name}',
  'Unassigned': 'Belum ditetapkan',
  'Est. unit price': 'Perkiraan harga satuan',
  'View {number}': 'Lihat {number}',
  'Convert to PO': 'Konversi ke PO',
  'Delete requisition': 'Hapus permintaan barang',
  'Step {step} of {total}: awaiting {role} approval.': 'Langkah {step} dari {total}: menunggu persetujuan {role}.',
  'approver': 'penyetuju',
  'You can approve or reject this step.': 'Anda dapat menyetujui atau menolak langkah ini.',
  'You do not hold the role required for this step.': 'Anda tidak memiliki peran yang diperlukan untuk langkah ini.',
  'Rejected: {comment}': 'Ditolak: {comment}',
  'Approved: {comment}': 'Disetujui: {comment}',
  'Estimated total': 'Perkiraan total',
  'Purchase orders': 'Pesanan pembelian',
  'Unassigned supplier': 'Pemasok belum ditetapkan',
  'Approval chain': 'Rantai persetujuan',
  'Authorisation': 'Otorisasi',
  'Requester signature': 'Tanda tangan pemohon',
  'Approver signature': 'Tanda tangan penyetuju',
  '— not signed —': '— belum ditandatangani —',
  'Add a comment for the team…': 'Tambahkan komentar untuk tim…',
  'Comment': 'Komentar',

  // --- Comment composer (mentions + attachments) -----------------------------
  'Add a comment — type @ to mention a colleague…':
    'Tambahkan komentar — ketik @ untuk menyebut rekan kerja…',
  'Attach': 'Lampirkan',
  'A comment can carry at most {n} attachments.': 'Satu komentar maksimal memuat {n} lampiran.',
  '"{name}" is larger than {n} MB.': '"{name}" lebih besar dari {n} MB.',
  'Could not upload "{name}"': 'Tidak dapat mengunggah "{name}"',
  'Remove {name}': 'Hapus {name}',
  'shared attachment(s)': 'membagikan lampiran',
  'Edit your comment — type @ to mention a colleague…':
    'Ubah komentar Anda — ketik @ untuk menyebut rekan kerja…',
  'Could not update comment': 'Tidak dapat memperbarui komentar',
  '(edited)': '(diubah)',
  'Comment removed': 'Komentar dihapus',
  'Delete this comment?': 'Hapus komentar ini?',
  'Yes, delete': 'Ya, hapus',
  'Could not delete comment': 'Tidak dapat menghapus komentar',

  'No activity yet': 'Belum ada aktivitas',
  'Lifecycle events and comments will appear here.': 'Peristiwa siklus dokumen dan komentar akan muncul di sini.',
  'Approve requisition': 'Setujui permintaan barang',
  'Reject requisition': 'Tolak permintaan barang',
  'Optionally add a note for the requester.': 'Tambahkan catatan untuk pemohon (opsional).',
  'Tell the requester why this is being rejected.': 'Beri tahu pemohon alasan penolakan ini.',
  'Comment (optional)': 'Komentar (opsional)',
  'Reason': 'Alasan',
  'Cancel requisition': 'Batalkan permintaan barang',
  "Cancelling stops this requisition from being approved or ordered. This can't be undone.": 'Pembatalan menghentikan permintaan barang ini agar tidak disetujui atau dipesan. Tindakan ini tidak dapat dibatalkan.',
  "Permanently delete {number}? This can't be undone.": 'Hapus {number} secara permanen? Tindakan ini tidak dapat dibatalkan.',

  // --- Form page ---------------------------------------------------------------
  'Only draft requisitions can be edited.': 'Hanya draf permintaan barang yang dapat diubah.',
  'Could not load requisition': 'Tidak dapat memuat permintaan barang',
  '— Unassigned —': '— Belum ditetapkan —',
  'Supplies this item': 'Memasok barang ini',
  'Not on price list': 'Tidak ada di daftar harga',
  '— No location —': '— Tanpa lokasi —',
  '— None —': '— Tidak ada —',
  'Enter a title.': 'Masukkan judul.',
  'Every line needs a description.': 'Setiap baris memerlukan deskripsi.',
  '"{line}" needs a quantity greater than 0.': '"{line}" memerlukan kuantitas lebih dari 0.',
  'A line': 'Sebuah baris',
  'Check these before saving': 'Periksa hal berikut sebelum menyimpan',
  'Give the requisition a title.': 'Beri judul pada permintaan barang.',
  'Add at least one line before saving.': 'Tambahkan setidaknya satu baris sebelum menyimpan.',
  'Line {n} needs a description.': 'Baris {n} memerlukan deskripsi.',
  'Line {n} needs a quantity greater than 0.': 'Baris {n} memerlukan kuantitas lebih dari 0.',
  'The title is too long (max 200 characters).': 'Judul terlalu panjang (maks 200 karakter).',
  'The description on line {n} is too long (max 500 characters).': 'Deskripsi pada baris {n} terlalu panjang (maks 500 karakter).',
  'The estimated price on line {n} cannot be negative.': 'Perkiraan harga pada baris {n} tidak boleh negatif.',
  '{number} submitted for approval': '{number} diajukan untuk persetujuan',
  'Submitted over budget': 'Diajukan melebihi anggaran',
  'Requisition updated': 'Permintaan barang diperbarui',
  '{number} created': '{number} dibuat',
  'Could not save requisition': 'Tidak dapat menyimpan permintaan barang',
  'Edit requisition': 'Ubah permintaan barang',
  'Request goods for a property/location. Submit it to route for approval.': 'Minta barang untuk properti/lokasi. Ajukan agar diteruskan untuk persetujuan.',
  'e.g. Weekend bar restock': 'mis. Pengisian ulang bar akhir pekan',
  'Deliver-to location': 'Lokasi pengiriman',
  'Context for approvers (optional)': 'Konteks untuk penyetuju (opsional)',
  'Line items': 'Baris barang',
  'Search catalog…': 'Cari katalog…',
  'Search items…': 'Cari barang…',
  'Search name or SKU…': 'Cari nama atau SKU…',
  'Searching…': 'Mencari…',
  'No catalog matches': 'Tidak ada katalog yang cocok',
  'Catalog item': 'Barang katalog',
  'Supplier…': 'Pemasok…',
  'Search suppliers…': 'Cari pemasok…',
  'No supplier matches': 'Tidak ada pemasok yang cocok',
  'Preferred supplier': 'Pemasok pilihan',
  'Remove line': 'Hapus baris',
  'Coding': 'Pengodean',
  'Line cost centre': 'Pusat biaya baris',
  'Line GL account': 'Akun GL baris',
  'Add blank line': 'Tambah baris kosong',
  'Save draft': 'Simpan draf',
  'Save & submit': 'Simpan & ajukan',

  // --- Vendor assignment at conversion -----------------------------------------
  'Assign vendors': 'Tetapkan vendor',
  'Pick a vendor for each line. One purchase order is created per vendor.': 'Pilih vendor untuk setiap baris. Satu pesanan pembelian dibuat per vendor.',
  'Assign all lines to': 'Tetapkan semua baris ke',
  'Select vendor…': 'Pilih vendor…',
  'Vendor for {line}': 'Vendor untuk {line}',
  '{count} line(s) have no vendor and will be grouped into one purchase order without a supplier.': '{count} baris belum memiliki vendor dan akan digabungkan ke satu pesanan pembelian tanpa pemasok.',
  'Create {count} purchase order(s)': 'Buat {count} pesanan pembelian',

  // --- Print page ------------------------------------------------------------
  'Could not load requisition.': 'Tidak dapat memuat permintaan barang.',
  'Print / Save as PDF': 'Cetak / Simpan sebagai PDF',
  'Purchase Requisition': 'Permintaan Pembelian Barang',
  'Deliver to': 'Kirim ke',
  'Step {order}': 'Langkah {order}',
  'Audit trail': 'Jejak audit',
  'Generated {time}': 'Dibuat {time}',

  // --- Approval chain (approvals feature) --------------------------------------
  'Any approver': 'Penyetuju mana pun',
  'Step {order}: {role}': 'Langkah {order}: {role}',
  'Awaiting': 'Sedang menunggu',
  'Skipped': 'Dilewati',
  'Triggered ≥ {amount}': 'Terpicu ≥ {amount}',
  '(on behalf of {name})': '(atas nama {name})',
  '{name} signature': 'Tanda tangan {name}',

  'Only draft or pending-approval requisitions can be edited.':
    'Hanya permintaan berstatus draf atau menunggu persetujuan yang dapat diedit.',

  // Supporting files on the requisition form
  'Supporting files': 'Berkas pendukung',
  'Supporting files (required)': 'Berkas pendukung (wajib)',
  'A photo, supplier quote or specification is required before this requisition can be submitted.':
    'Foto, penawaran pemasok, atau spesifikasi wajib ada sebelum permintaan ini dapat diajukan.',
  'Optional. Attach a photo, supplier quote or specification to help approvers decide.':
    'Opsional. Lampirkan foto, penawaran pemasok, atau spesifikasi untuk membantu penyetuju memutuskan.',
  '{n} file(s) already attached to this requisition.': '{n} berkas sudah dilampirkan pada permintaan ini.',
  'These upload automatically when you save.': 'Berkas ini terunggah otomatis saat Anda menyimpan.',
  'Attach at least one file (a photo, quote or specification) before submitting.':
    'Lampirkan setidaknya satu berkas (foto, penawaran, atau spesifikasi) sebelum mengajukan.',
  '{number} was saved, but a file could not be uploaded': '{number} tersimpan, tetapi sebuah berkas gagal diunggah',
};

export default requisitions;
